<template>
    <table name="totals">
    <tr>
        <td>Subtotal:</td>
        <td>{{totalExcludingTax.toFixed(2)}}</td>
    </tr>
    <tr>
        <td>Tax:</td>
        <td>{{totalTax.toFixed(2)}}</td>
    </tr>
    <tr>
        <td>Delivery fee:</td>
        <td>{{deliveryFee.toFixed(2)}}</td>
    </tr>
    <tr v-if="serviceFee > 0">
        <td>Service fee:</td>
        <td>{{serviceFee.toFixed(2)}}</td>
    </tr>
    <tr>
        <td>Gratuity:</td>
        <td>{{gratuity.toFixed(2)}}</td>
    </tr>
    <tr>
        <td>Total:</td>
        <td>{{totalIncludingFees.toFixed(2)}}</td>
    </tr>
</table>
</template>
<script>
    export default {
        watch: {
            $route() {
            }
        },
        data() {
            return {
                totalExcludingTax: 0,
                totalTax: 0,
                deliveryFee: 0,
                serviceFee: 0,
                gratuity: 0,
                totalIncludingFees: 0
            };
        },
        created() {
        },
        methods: {
            populate(data){
                this.totalExcludingTax = data.totalExcludingTax;
                this.totalTax = data.totalTax;
                this.deliveryFee = data.deliveryFee;
                this.serviceFee = data.serviceFee;
                this.gratuity = data.gratuity;
                this.totalIncludingFees = data.totalIncludingFees;
            }
        }
    };
</script>
<!-- Styles -->
<style scoped>
/* Totals */
section[name="Totals"] table[name="totals"] {
    margin: 0px;
    width: 100%;
    border-collapse: separate;
    border-spacing: 0 6px;
}

    section[name="Totals"] table[name="totals"] tr td:first-child {
        text-align: right;
        padding-right: 18px;
    }

    section[name="Totals"] table[name="totals"] tr td:last-child {
        font-weight: bold;
        text-align: right;
    }

    section[name="Totals"] table[name="totals"] tr:last-child td {
        padding-top: 10px;
    }

        section[name="Totals"] table[name="totals"] tr:last-child td:last-child {
            border-top: 1px solid black;
        }
</style>